import Vue from 'vue';
export default new Vue();



// WEBPACK FOOTER //
// ./src/js/util/bus.js